const cartContainer = document.getElementById("side-cart");

// Function to update the side cart HTML with new cart data
const updateSideCart = (cartData) => {
  const cartLoop = cartContainer.querySelector(".cart-loop");
  cartLoop.innerHTML = "";

  //console.log(cartData);

  cartData.items.forEach(item => {
    const itemElement = document.createElement("div");
    itemElement.classList.add("item");
    itemElement.setAttribute("data-key", item.key);
    
    itemElement.innerHTML = `
      <div class="left">
        <a class="image" href="${item.url}">
          <img src="${item.image}" alt="${item.product_title}">
        </a><!-- Image -->
    
        <div class="details">
          ${item.variant_title && item.variant_title !== "Default Title" ? `
            <span class="variant">
              ${item.variant_title}
            </span><!-- Variant -->
          ` : `
            <a class="title ${item.variant_title && item.variant_title !== "Default Title" ? 'grey' : ''}" href="${item.url}">
              ${item.product_title}
            </a><!-- Title -->
          `}
          <div class="price">
            ${item.quantity} x ${Shopify.formatMoney(item.price, '${{ amount_no_decimals }}')}
          </div>
    
          <a href="#" class="remove-btn btn grey-btn" data-key="${item.key}">Remove</a><!-- Remove Button -->
        </div><!-- Details -->
      </div><!-- Left -->
    `;
    
    cartLoop.appendChild(itemElement);
    
  });

  const subtotalElement = cartContainer.querySelector(".bottom .total span:last-child");
  subtotalElement.innerText = Shopify.formatMoney(cartData.total_price, "${{ amount_no_decimals }}");
};

// Update subtotal function
// const updateSubtotal = (totalPrice) => {
//   document.querySelectorAll(".total-price").forEach((element) => {
//     element.innerText = Shopify.formatMoney(totalPrice, '${{ amount_no_decimals }}');
//   });
// };
const freeShippingThreshold = 5000; // in cents

const updateSubtotal = (totalPrice) => {
  // Update total price display
  document.querySelectorAll(".total-price").forEach((element) => {
    element.innerText = Shopify.formatMoney(totalPrice, '${{ amount_no_decimals }}');
  });

  // Update free shipping message
  // const shippingElement = document.querySelector(".shipping");
  // if (!shippingElement) return;

  // if (totalPrice >= freeShippingThreshold) {
  //   shippingElement.innerText = "Free Shipping";
  // } else {
  //   const remainingAmount = freeShippingThreshold - totalPrice;
  //   shippingElement.innerText = `Add ${Shopify.formatMoney(remainingAmount, '${{ amount_no_decimals }}')} for free shipping`;
  // }
};


// Helper function to update cart count
const updateCartCount = (itemCount) => {
  if(itemCount == 0){
    document.getElementById("side-cart").classList.add("empty");
  } else {
    document.getElementById("side-cart").classList.remove("empty");
  }

  // document.querySelectorAll(".cart-count").forEach((element) => {
  //   element.innerText = itemCount;
  // });

  document.querySelectorAll(".cart-count").forEach((element) => {
    if (itemCount === 0 && element.closest(".cart-count-dot")) {
      element.innerText = ""; // Leave empty
      element.closest(".cart-count-dot").classList.add("empty");
    } else {
      element.innerText = itemCount;
      if(element.closest(".cart-count-dot")){
        element.closest(".cart-count-dot").classList.remove("empty");
      }
    }
  });  
};

//Quantity Management
/*
cartContainer.addEventListener("input", (event) => {
  if (event.target.classList.contains("quantity-input")) {
    const quantity = parseInt(event.target.value, 10);
    const itemKey = event.target.name.split("[")[1].replace("]", "");
      
    if (isNaN(quantity) || quantity <= 0) {
      event.target.value = 1;
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: { [itemKey]: event.target.value } })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Cart updated successfully:', data);
      updateCartCount(data.item_count);
      updateSubtotal(data.total_price);
      updateSideCart(data);
    })
    .catch(error => console.error('Error updating cart:', error));
  }
});
*/

//Remove Item
cartContainer.addEventListener("click", (event) => {
  if (event.target.classList.contains("remove-btn")) {
    event.preventDefault();
    const itemKey = event.target.getAttribute("data-key");
    const itemElement = event.target.closest(".item");

    itemElement.remove();

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: { [itemKey]: 0 } })
    })
    .then(response => response.json())
    .then(data => {
      //console.log('Item removed successfully:', data);
      updateCartCount(data.item_count);
      updateSubtotal(data.total_price);
      updateSideCart(data);
    })
    .catch(error => console.error('Error removing item:', error));
  }
});

cartContainer.querySelectorAll(".close-cart-btn").forEach(btn => {
  btn.addEventListener("click", (event) => {
    event.preventDefault();
    cartContainer.classList.remove("open");
  });
});

//Display Cart
const getCartContents = () => {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
  .then((response) => response.json())
  .then((data) => {
    //console.log('Cart contents:', data);
    updateCartCount(data.item_count);
    updateSideCart(data); // Function to update the side cart HTML
  })
  .catch((error) => {
    console.error('Error fetching cart contents:', error);
  });
}

getCartContents();

const setATCForms = () => {
  let addToCartForms = document.querySelectorAll(".product-atc form");

  addToCartForms.forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const formData = new FormData(form);
  
      try {
        const addResponse = await fetch("/cart/add", {
          method: "POST",
          body: formData,
          headers: { "X-Requested-With": "XMLHttpRequest" }
        });
  
        if (addResponse.ok) {
          const cartResponse = await fetch("/cart.js", {
            method: "GET",
            headers: { "X-Requested-With": "XMLHttpRequest" }
          });
  
          if (cartResponse.ok) {
            const cartData = await cartResponse.json();
            updateCartCount(cartData.item_count);
            updateSubtotal(cartData.total_price);
            updateSideCart(cartData);
            document.getElementById("side-cart").classList.add("active");
          } else {
            console.error("Failed to retrieve updated cart data");
          }
        } else {
          console.error("Failed to add item to cart");
        }
      } catch (error) {
        console.error("Error adding item to cart:", error);
      }
    });
  });
}

setATCForms();